module.exports = __webpack_public_path__ + "static/media/expand.3c0d4fb2.svg";